import {EInvoiceTransaction} from "../../components";


export const EInvoiceTransactionPage = () => {
  return <EInvoiceTransaction />;
};
